import { Button } from '@components/button';
import { saveFile } from '@helper-functions/save-file';
import { useNotifications } from '@notifications/Notifications';
import { formatISO } from 'date-fns';
import { LogType } from './types';

interface JobsManagerPreviewLogsScreenSaveToFileProps {
  logs: LogType[];
  name: string;
}

export const SaveLogsToFileButton = ({
  logs,
  name,
}: JobsManagerPreviewLogsScreenSaveToFileProps) => {
  const { addNotification } = useNotifications();
  const downloadLogs = () => {
    const data = logs
      .map(
        (log) =>
          `${new Date(log.timestamp).toISOString()}  ${new Date(
            log.ingestionTime,
          ).toISOString()} ${log.message}`,
      )
      .join('\n');
    const filename = `${name || formatISO(new Date())}.log`;
    const url = window.URL.createObjectURL(new Blob([data], { type: 'text/plain' }));
    saveFile({ url, name: filename });
    addNotification({ type: 'success', text: 'Starting download...', duration: 6000 });
  };

  return <Button onClick={downloadLogs}>Save to File</Button>;
};
